<template>
  <div class="shop-orders-page">
    <header class="page-head">
      <van-icon
        name="arrow-left"
        @click="$router.back()"
      />
      <h1>{{ $t('shopOrders.title') }}</h1>
    </header>

    <nav class="order-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.stat"
        type="button"
        :class="{ active: activeStat === tab.stat }"
        @click="switchTab(tab.stat)"
      >
        {{ $t(tab.label) }}
      </button>
    </nav>

    <main class="order-list">
      <article
        v-for="item in list"
        :key="item.id"
        class="order-card"
        @click="goDetail(item)"
      >
        <img
          :src="orderImage(item.img)"
          alt=""
          @error="onImageError"
        >
        <div class="order-info">
          <p>{{ formatBrowserTime(item.ctime, 'short') }}</p>
          <h2>{{ item.title }}</h2>
          <div class="money-line">
            <span>{{ $t('shopOrders.price') }}:</span>
            <strong>{{ item.total }}</strong>
          </div>
          <div class="money-line">
            <span>{{ $t('shopOrders.commission') }}:</span>
            <strong>{{ item.fee }}</strong>
          </div>
        </div>
        <em
          v-if="item.stat==3"
          style=" background: #ccc;"
        >{{ statusLabel(item.stat) }}</em>
        <em v-else>{{ statusLabel(item.stat) }}</em>
      </article>

      <div
        v-if="!loading"
        class="list-tip"
      >
        {{ list.length ? $t('shopOrders.noMore') : $t('shopOrders.empty') }}
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Shoporders',
  data() {
    return {
      app: {},
      activeStat: 0,
      list: [],
      page: 1,
      limit: 20,
      loading: false,
      fallback: require('../images/shop2/pro.png'),
      tabs: [
        { stat: 0, label: 'shopOrders.pending' },
        { stat: 1, label: 'shopOrders.waiting' },
        { stat: 2, label: 'shopOrders.staying' },
        { stat: 3, label: 'shopOrders.canceled' },
        { stat: 4, label: 'shopOrders.completed' },
      ],
    };
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('walfare', false);
    }
    var stat = Number(this.$route.query.stat);
    this.activeStat = [0, 1, 2, 3, 4].indexOf(stat) > -1 ? stat : 0;
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      this.loadList();
    },
    loadList() {
      this.loading = true;
      Fetch('/user/shop_orders', {
        stat: this.activeStat,
        page: this.page,
        limit: this.limit,
      }, null, true).then((r) => {
        this.list = (r.data && r.data.list) || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    switchTab(stat) {
      if (this.activeStat === stat) return;
      this.activeStat = stat;
      this.page = 1;
      this.list = [];
      this.$router.replace({
        path: '/shoporders',
        query: { stat },
      });
      this.loadList();
    },
    statusLabel(stat) {
      var map = {
        0: 'shopOrders.pending',
        1: 'shopOrders.waiting',
        2: 'shopOrders.staying',
        3: 'shopOrders.canceled',
        4: 'shopOrders.completed',
      };
      return this.$t(map[Number(stat)] || 'shopOrders.pending');
    },
    orderImage(path) {
      if (!path) return this.fallback;
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    onImageError(event) {
      event.target.src = this.fallback;
    },
    goDetail(item) {
      this.$router.push({
        path: '/shopodetail',
        query: { id: item.id },
      });
    },
    kefuTo() {
      if (this.app && this.app.kefu_link) {
        window.location.href = this.app.kefu_link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.shop-orders-page {
  min-height: 100vh;
  background: #eaf4ff;
  color: #061429;
  padding-bottom: 24px;
}

.page-head {
  height: 58px;
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f7fc;
  border-bottom: 1px solid #edf0f5;
}

.page-head .van-icon {
  position: absolute;
  left: 24px;
  top: 20px;
  color: #061429;
  font-size: 22px;
}

.page-head h1 {
  margin: 0;
  font-size: 14px;
  line-height: 58px;
  font-weight: 500;
}

.order-tabs {
  height: 58px;
  position: sticky;
  top: 58px;
  z-index: 3;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background: #fff;
}

.order-tabs button {
  position: relative;
  border: 0;
  background: transparent;
  color: #4b5563;
  font-size: 14px;
  line-height: 58px;
}

.order-tabs .active {
  color: #061429;
  font-weight: 700;
}

.order-tabs .active:after {
  content: '';
  position: absolute;
  left: 27px;
  right: 27px;
  bottom: 0;
  height: 3px;
  border-radius: 2px;
  background: #2094ff;
}

.order-list {
  padding: 14px 14px 80px;
}

.order-card {
  min-height: 146px;
  position: relative;
  display: flex;
  overflow: hidden;
  margin-bottom: 12px;
  border-radius: 10px;
  background: #fff;
}

.order-card img {
  width: 162px;
  min-height: 146px;
  flex: 0 0 162px;
  object-fit: cover;
  background: #e5e7eb;
}

.order-info {
  min-width: 0;
  flex: 1;
  padding: 16px 70px 12px 14px;
}

.order-info p {
  margin: 0 0 7px;
  color: #9ca3af;
  font-size: 12px;
  line-height: 16px;
}

.order-info h2 {
  height: 42px;
  overflow: hidden;
  margin: 0 0 15px;
  color: #020617;
  font-size: 14px;
  line-height: 21px;
  font-weight: 700;
}

.money-line {
  display: flex;
  align-items: center;
  color: #9ca3af;
  font-size: 12px;
  line-height: 18px;
}

.money-line strong {
  margin-left: 8px;
  color: #061429;
  font-size: 14px;
  font-weight: 500;
}

.order-card em {
  position: absolute;
  right: 14px;
  bottom: 19px;
  min-width: 64px;
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  background: #f8264d;
  color: #fff;
  font-style: normal;
  font-size: 12px;
  line-height: 34px;
  text-align: center;
}

.list-tip {
  margin: 58vh 0 0;
  color: #9ca3af;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.order-card + .list-tip {
  margin-top: 230px;
}

.kefu {
  position: fixed;
  right: 26px;
  bottom: 108px;
  z-index: 12;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  background: linear-gradient(180deg, #1884ff 0%, #1884ff 68%, #f70720 68%, #f70720 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.kefu .van-icon {
  font-size: 36px;
}
</style>
